import { desktopWorldCupPageAdsBuilder } from "./desktopWorldCupPageAdsBuilder";
import { mobileWorldCupPageAdsBuilder } from "./mobileWorldCupPageAdsBuilder";
import { deviceUtil, pageUtil } from "@repo/lib-common";
import { DomainPageClient } from "@repo/lib-domain-tag";
const PageTypeEnum = pageUtil.PageTypeEnum;
let isPageClientInitiated = false;
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-var
declare var pbjs: any;
export const initPageClient_WorldCup = function () {
    if (isPageClientInitiated) return;
    isPageClientInitiated = true;
    const device = window.domainDevice || new deviceUtil.DeviceTypeInfo();
    const pageClient = new DomainPageClient();
    pageClient.device = device;
    pageClient.pageType = PageTypeEnum.worldCup;


    if (device.isMobile()) {
        pageClient.adsBuilder = mobileWorldCupPageAdsBuilder.setAdsConfAndApply(window.domainAdsConfForMobile);
    } else {
        pageClient.adsBuilder = desktopWorldCupPageAdsBuilder.setAdsConfAndApply(window.domainAdsConfForDesktop);
    }

    window.domainClient = pageClient;
    const isLoggedIn = pageClient.doesCookieExists('loggedIn') && pageClient.doesCookieExists('_sgf_facebook_name') && pageClient.doesCookieExists('_sgf_user_pids');
    pageClient.adsBuilder.setIsEnabled(!isLoggedIn);
    pageClient.adsBuilder.executeAsPbjsCommand(() => {
        pbjs.enableAnalytics({
            provider: 'yandex',
            options: {
                counters: [48985463],
            },
        });
    }
    );
    pageClient.adsBuilder.execute();
}
initPageClient_WorldCup();
